import { Tab, Tabs, Typography } from "@mui/material";
import { ReactComponent as AlertTriangleIcon } from "components/Icons/alert-triangle.svg";
import { ReactComponent as CloudUploadIcon } from "components/Icons/cloudUploadIcon.svg";
import { ReactComponent as RemoveIcon } from "components/Icons/removeIcon.svg";
import { useMessage } from "hooks/intl";
import Dropzone, { FileRejection } from "react-dropzone";
import { ImageType } from "./ImageUpload";
import { useStyles } from "./styles";

type Props = {
  error?: boolean;
  disabled?: boolean;
  header?: string;
  onChange?: (acceptedFiles: File[], rejectedFiles: FileRejection[]) => void;
  value: ImageType[];
  onDelete: (item: ImageType, id: string) => void;
};
export function DragAndDrop({
  error,
  disabled,
  header = "",
  onChange,
  value,
  onDelete,
}: Props) {
  const classes = useStyles();
  const { message } = useMessage();
  const isAnyValueAdded = value && value.length > 0;

  return (
    <div>
      <Dropzone
        disabled={disabled}
        maxSize={3145728} // in bytes === 3mb
        multiple={true}
        onDrop={onChange}
        accept={{ "image/png": [".png"], "image/jpg": [".jpeg", ".jpg"] }}
      >
        {({ getRootProps, getInputProps }) => (
          <div
            data-test-id="image-drag-and-drop-container"
            className={classes.dragDropInput}
            {...getRootProps()}
          >
            <input
              {...getInputProps()}
              data-test-id="image-drag-and-drop"
              className={classes.hiddenInput}
            />
            <CloudUploadIcon />
            <span className={classes.dragDropHeader}>{header}</span>
            <Typography className={classes.description}>
              <Typography fontSize={16} className={classes.descPurple}>
                {message({ id: "clickToUpload" })}{" "}
              </Typography>
              <Typography fontSize={16}>
                {message({ id: "orDragAndDropFile" })}
              </Typography>
            </Typography>
            <Typography className={classes.supportedFiles}>
              <span>
                {message(
                  { id: "graphicFileMaxSize" },
                  {
                    size: 3,
                  },
                )}
              </span>
            </Typography>
          </div>
        )}
      </Dropzone>
      {isAnyValueAdded && (
        <div className={classes.dragDropFilesWrapper}>
          <Tabs
            allowScrollButtonsMobile
            scrollButtons
            variant="scrollable"
            value={false}
            className={`${classes.tabs} ${classes.indicator}`}
            classes={{
              flexContainer: classes.flexContainer,
              scrollButtons: classes.scrollButtons,
            }}
          >
            {value.map((item) => (
              <Tab
                className={classes.item}
                key={item.id}
                label={
                  <div
                    className={`${classes.dragDropFiles} ${
                      error ? classes.error : ""
                    }`}
                    key={item.id}
                  >
                    <img
                      alt={item.path}
                      className={classes.thumb}
                      src={item.preview}
                      title={item.path}
                    />

                    <div>
                      {error && (
                        <AlertTriangleIcon
                          data-test-id="import-error-icon"
                          className={classes.errorIcon}
                          fontSize="medium"
                        />
                      )}
                      {!disabled && (
                        <RemoveIcon
                          className={classes.removeIcon}
                          onClick={() => onDelete?.(item, item.id)}
                        />
                      )}
                    </div>
                  </div>
                }
              />
            ))}
          </Tabs>
        </div>
      )}
    </div>
  );
}
